import { useEffect } from 'react'

import { getIsFetchingOrNotStarted } from '@/reducers/fetch'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'

import { selectCurrentAnnualTaxYear } from '@/featuresV1/Admin/AnnualTaxDetails/annualTaxDetails.selector'
import { fetchAllQuarterlyTaxEstimateDetailsIfNeeded } from '@/featuresV1/Admin/QuarterlyTaxEstimateDetails/quarterlyTaxEstimateDetails.slice'
import { selectActiveQuarterlyTaxEstimateDetails } from '@/featuresV1/Admin/QuarterlyTaxEstimateDetails/quarterlyTaxEstimateDetails.selector'
import {
  getIncompleteAnnualTaxActionItemsForYear,
  getIncompleteEoyActionItems,
  getIncompleteQuarterlyTaxActionItemsForYearAndQuarter,
} from './lib/userActionItems.selectors'
import {
  fetchUserActionItemsIfNeeded,
  FETCH_USER_ACTION_ITEMS_KEY,
} from './lib/userActionItems.slice'

import { TaxActionItemsCard } from './cards/TaxActionItemsCard'
import { EoyActionItemsCard } from './cards/EoyActionItemsCard'
import { QTEActionItemsCard } from './cards/QTEActionItemsCard'
import { ToDosCard } from './cards/ToDosCard'

export const UserActionItemsCard = () => {
  const dispatch = useAppDispatch()
  // Action items will be sorted/grouped by "Category" by default
  const currentTaxYear = useReselector(selectCurrentAnnualTaxYear)
  const incompleteEoyActionItems = useReselector(getIncompleteEoyActionItems)

  const currentTaxQuarterDetails = useReselector(
    selectActiveQuarterlyTaxEstimateDetails
  )

  const incompleteAnnualTaxActionItems = useReselector(
    getIncompleteAnnualTaxActionItemsForYear,
    currentTaxYear
  )

  const incompleteQuarterlyTaxActionItems = useReselector(
    getIncompleteQuarterlyTaxActionItemsForYearAndQuarter,
    {
      taxYear: currentTaxQuarterDetails?.taxYear,
      taxQuarter: currentTaxQuarterDetails?.taxQuarter,
    }
  )

  const isFetching = useReselector(
    getIsFetchingOrNotStarted,
    FETCH_USER_ACTION_ITEMS_KEY
  )

  useEffect(() => {
    /* Always fetch */
    dispatch(fetchUserActionItemsIfNeeded({ forceFetch: true }))
    dispatch(fetchAllQuarterlyTaxEstimateDetailsIfNeeded())
  }, [dispatch])

  // Don't show regular todos if Tax and EOY action lists both exist
  const showRegularTodos =
    incompleteEoyActionItems.length === 0 ||
    incompleteAnnualTaxActionItems.length === 0

  return (
    <>
      {incompleteEoyActionItems.length > 0 && !isFetching && (
        <EoyActionItemsCard
          incompleteEoyActionItems={incompleteEoyActionItems}
          isUrgent
        />
      )}

      {incompleteAnnualTaxActionItems.length > 0 && !isFetching && (
        <TaxActionItemsCard
          incompleteActionItems={incompleteAnnualTaxActionItems}
          isUrgent={incompleteEoyActionItems.length === 0}
        />
      )}

      {incompleteQuarterlyTaxActionItems.length > 0 && !isFetching && (
        <QTEActionItemsCard
          incompleteActionItems={incompleteQuarterlyTaxActionItems}
          isUrgent={
            incompleteEoyActionItems.length === 0 &&
            incompleteAnnualTaxActionItems.length === 0
          }
        />
      )}

      {showRegularTodos && <ToDosCard isFetching={isFetching} />}
    </>
  )
}
